<script lang="ts">
    import HtmlFragmentLoader from "../HtmlFragmentLoader/HtmlFragmentLoader.svelte";

    import { tmemState } from "./TmemState";
    import { glosbeUiServerUrl } from "@app/services/glosbe-ui-server-endpoints";

    const mode = $tmemState.mode;
    const stem = $tmemState.stem;
    const includedAuthorsIds = $tmemState.includedAuthors
        .map((author) => author.id)
        .join(",");
    const excludedAuthorsIds = $tmemState.excludedAuthors
        .map((author) => author.id)
        .join(",");
    export let page: number;

    const url = `${glosbeUiServerUrl}/fragment/tmem?page=${page}&mode=${mode}&stem=${stem}&includedAuthors=${includedAuthorsIds}&excludedAuthors=${excludedAuthorsIds}`;
</script>

<HtmlFragmentLoader {url} showHideButton={false} />
